module.exports = __webpack_public_path__ + "static/media/Thirdpartypet.5a82abb3.svg";